import React from 'react';

const isEnabled = (v) => !(v === 0 || v === '0' || v === false || v === 'false' || v == null);

const itemStyle = (selected, enabled) => ({
  padding: '10px 12px',
  borderRadius: 10,
  border: '1px solid ' + (enabled ? '#dfe3e6' : '#f1c2c2'),
  background: selected ? '#e9f7ff' : enabled ? '#ffffff' : '#fff5f5',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: enabled ? 1 : 0.8,
});

const metaStyle = { fontSize: 12, color: '#666' };
const btnStyle = {
  padding: '4px 8px',
  borderRadius: 6,
  border: '1px solid red',
  background: 'red',
  color: '#fff',
  fontSize: 12,
};

const statusPill = (enabled) => ({
  padding: '2px 8px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 600,
  border: `1px solid ${enabled ? '#1a7f37' : '#b3261e'}`,
  color: enabled ? '#1a7f37' : '#b3261e',
  background: enabled ? '#e9f7ef' : '#fdecea',
});

const EmployeeList = ({
  employees = [],
  selectedEmployeeId = null,
  onSelect,
  onOpen,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 , maxHeight: '75vh', overflowY: 'auto'}}>
      {employees.map((e) => {
        const selected = String(e.id) === String(selectedEmployeeId);
        // Prefer 'enabled', fallback to legacy flags if present
        const enabled = isEnabled(e.enabled ?? e.is_active ?? e.active ?? 1);

        return (
          <div
            key={e.id}
            style={itemStyle(selected, enabled)}
            onClick={() => onSelect?.(e)}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 600 }}>
                {e.display_name || e.username || e.email || `Employee ${e.id}`}
              </div>
              <div style={metaStyle}>
                {e.username ? `@${e.username}` : e.email || ''}
                {e.role ? ` • ${e.role}` : ''}
                {!enabled ? ' • Inactive' : ''}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <span style={statusPill(enabled)}>
                {enabled ? 'Active' : 'Inactive'}
              </span>
              <button
                type="button"
                style={btnStyle}
                onClick={(ev) => { ev.stopPropagation(); onOpen?.(e); }}
              >
                Open
              </button>
            </div>
          </div>
        );
      })}
      {employees.length === 0 && (
        <div style={{ color: '#777', fontSize: 13, padding: 8 }}>
          No employees.
        </div>
      )}
    </div>
  );
};

export default EmployeeList;
